import React, { useState, useEffect , useRef } from "react";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import { useDispatch, useSelector } from "react-redux";
import {
  getClientCreateActions,
  setCLientetrieveAction,
  setClientEditActions,
} from "../../../Redux/Slice";
import swal from "sweetalert2";
import Swal from "sweetalert2";

const ClientCreate = (props) => {
  const {
    show,
    setShow,
    currentPage,
    EditId,
    //  Datamonth
  } = props;
  const initialState = {
    Client: "",
    description: "",
    pre_area: null,
    project_number: null,
  };
  /// console.log(EditId, "IDs");
  const Swal = require("sweetalert2");
  const [ErrorInde, setErrInde] = useState(0);

  const dispatch = useDispatch();
  const State = useSelector((state) => state);
  const [datas, setDatas] = useState(initialState);
  const [ClientError, setClientError] = useState("");
  const [DescriptionError, setDescriptionError] = useState("");
  const [PreAERR, setPreErr] = useState("");
  const [projectErr, setProjectER] = useState("");
  const handleClose = () => {
    Swal.fire({
      title: `Do you want to exit ?`,
      // text: "You won't be able to revert this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#f26639",
      cancelButtonColor: "#F69338",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        setShow(false);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.close();
      }
    });
  };
  const HandleChanges = (e) => {
    if (e.target.name == "pre_area") {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value.slice(0, 4),
        };
      });
    } else {
      setDatas((prev) => {
        return {
          ...prev,
          [e.target.name]: e.target.value,
        };
      });
    }
  };
  useEffect(() => {
    if (EditId != undefined && EditId != "") {
      const payload = {
        EditId: EditId,
      };
      dispatch(setCLientetrieveAction(payload));
    }
  }, []);
  useEffect(() => {
    if (
       EditId != undefined &&
      EditId != "" &&
      State.ClientRetrieves.ClientRetrieve?.id
      &&
      State.ClientRetrieves.ClientRetrieve?.id  == EditId

    ) {
      setDatas({
        ...datas,
        Client: State.ClientRetrieves.ClientRetrieve.client_name,
        description: State.ClientRetrieves.ClientRetrieve.description,
        pre_area: State.ClientRetrieves.ClientRetrieve.pre_area,
        project_number: State.ClientRetrieves.ClientRetrieve.project_number,
      });
    }
  }, [State.ClientRetrieves.ClientRetrieve]);

  const HandleSubmit = () => {
    // console.log(datas);

    if (
      EditId == undefined ||
      EditId == "" ||
      !State.ClientRetrieves.ClientRetrieve.id
    ) {
      var a = 0;
      if (datas.Client == "") {
        a = 1;
        setClientError("*Client Name is Required");
      }
      if (datas.description == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }

      // if (datas.pre_area == "") {
      //   a = 1;
      //   setPreErr("*Pre Area  is Required");
      // }
      // if (datas.project_number == "") {
      //   a = 1;
      //   setProjectER("*Project Number is Required");
      // }

      if (a == 0 && ErrorInde == 0) {
        // console.log(datas ,"inner");

        Swal.fire({
          title: `Do you want to create client ?`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f26639",
          cancelButtonColor: "#F69338",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.isConfirmed) {
            const payload = {
              datas: datas,
              currentPage: currentPage,
              // month:Datamonth.month,
              // year: Datamonth.year,
            };
            dispatch(getClientCreateActions(payload, setShow(false)));
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.close();
          }
        });
      }
    }
  };

  const HandleSubmits = (e) => {
    e.preventDefault();
  };
   console.log(datas ,"8787oijlihdatas");
  const HandleEdits = () => {
    if (
      EditId != undefined &&
      EditId != "" &&
      State.ClientRetrieves.ClientRetrieve.id
    ) {
      var a = 0;
      if (datas.Client == "") {
        a = 1;
        setClientError("*Client Name is Required");
      }
      if (datas.description == "") {
        a = 1;
        setDescriptionError("*Description is Required");
      }

      // if (datas.pre_area == "") {
      //   a = 1;
      //   setPreErr("*Pre Area  is Required");
      // }
      // if (datas.project_number == "") {
      //   a = 1;
      //   setProjectER("*Project Number is Required");
      // }

      if (a == 0 && ErrorInde == 0) {
        // const payload = {
        //   datas: datas,
        //   currentPage: currentPage,
        //   EditId: EditId,
        // };

        // dispatch(setClientEditActions(payload, props.setShow()));

        Swal.fire({
          title: `Do you want to Save the Changes ?`,
          // text: "You won't be able to revert this",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#f26639",
          cancelButtonColor: "#F69338",
          confirmButtonText: "Yes",
        }).then((result) => {
          if (result.isConfirmed) {
            const payload = {
              datas: datas,
              currentPage: currentPage,
              EditId: EditId,
              // month:Datamonth.month,
              // year: Datamonth.year,
            };

            dispatch(setClientEditActions(payload, props.setShow()));
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            Swal.close();
          }
        });


        
      }
    }
  };

  const inputRef = useRef(null);
  // const preventZoom = (event) => {
  //   // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
  //   if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === "wheel")) {
  //     event.preventDefault();
  //   }
  
  //   // Prevent unwanted keys like 'e', '+', '-', '.' and Arrow keys
  //   if (["e", "E", "+", "-", "."].includes(event.key) || event.key === 'ArrowUp' || event.key === 'ArrowDown') {
  //     event.preventDefault();
  //   }
  // };
  // // Validate the pasted content and strip invalid characters
  // const handlePaste = (event) => {
  //   let paste = (event.clipboardData || window.clipboardData).getData('text');
    
  //   // Strip non-numeric characters (except for digits)
  //   const filtered = paste.replace(/[^0-9]/g, '');
    
  //   // Prevent the default paste action and set the input value to the filtered result
  //   event.preventDefault();
    
  //     event.target.value = filtered;
  //     HandleChanges({ target: { name: event.target.name, value: filtered } }); // Trigger onChange logic
    
  // };
  const preventZoom = (event) => {

   // Prevent zooming when Ctrl/Meta is pressed with "+" or "-" or the mouse wheel
   if ((event.ctrlKey || event.metaKey) && (event.key === '+' || event.key === '-' || event.type === 'wheel') || event._reactName == "onWheel"
 && event._reactName != "onKeyDown"
   ) {
     event.preventDefault();
   }

   // Prevent unwanted keys: 'e', '+', '-', '.', Arrow keys, and prevent zooming with the mouse wheel
   if (["e", "E", "+", "-", ".", "ArrowUp", "ArrowDown"].includes(event.key) || event.type === "wheel"
   || event._reactName == "onWheel" 
 &&   event._reactName != "onKeyDown") {
     event.preventDefault();
   }
 };
 
   

 const handlePaste = (event) => {
   const paste = (event.clipboardData || window.clipboardData).getData('text');
   const filtered = paste.replace(/[^0-9]/g, ''); // Strip non-numeric characters
   event.preventDefault();
   event.target.value = filtered;
   HandleChanges({ target: { name: event.target.name, value: filtered } });
 };

    
  useEffect(() => {
    const inputElement = inputRef.current;

    if (inputElement) {
      inputElement.addEventListener('wheel', preventZoom);
    }

    // Cleanup to remove the event listener when the component unmounts
    return () => {
      if (inputElement) {
        inputElement.removeEventListener('wheel', preventZoom);
      }
    };
  }, []);

  

  return (
    <>
      <div className="RoleCreatePopup">
        <div className="BeforePopUp">
          <div className="RolePopups" style={{width:"40%"}}>
            <div className="asds">
              <div class="ModalHeader">
                {EditId != undefined &&
                EditId != "" &&
                State.ClientRetrieves.ClientRetrieve.id ? (
                  <span className="UserCreate"> Client </span>
                ) : (
                  <span className="UserCreate"> Client </span>
                )}

                <div
                  className="CloseIcon"
                  onClick={(e) => {
                    handleClose(e);
                  }}
                >
                  <CloseOutlinedIcon />
                </div>
              </div>

              <form
                class="row g-3 form-fields-wrapper"
                //onClick={HandleSubmits}
              >
                <div class="col-6 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Client Name
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    value={datas.Client}
                    autoComplete="off"
                    // onChange={(e) => {
                    //   HandleChanges(e);
                    //   setClientError("");
                    // }}

                    onChange={(e) => {
                      const value = e.target.value.slice(0, 60);
                      HandleChanges(e);

                      e.target.value = value;
// console.log(value.length ,"length", value.length ==60);
                      // Handle validation
                      if (value.length == 60) {
                        setClientError(
                          "*Client name should not exceed 60 characters"
                        );
                        setErrInde(1);
                      } else {
                        setClientError("");
                        setErrInde(0);
                      }
                    }}
                    required
                    name="Client"
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {ClientError}
                  </p>
                </div>

                <div class="col-6 field-div">
                  <label
                    for="validationCustom01"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Pre Area 
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    onKeyDown={preventZoom}  
                    onPaste={handlePaste}   
                    onWheel={preventZoom}    

                    ref={inputRef}
                    value={datas.pre_area}
                    autoComplete="off"
                    onChange={(e) => {
                      HandleChanges(e);
                      setPreErr("");
                    }}
                    required
                    name="pre_area"

                    step="1"


                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{PreAERR}</p>
                </div>

                <div class="col-6 field-div">
                  <label
                    for="validationCustom02"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Project Number
                    {/* <span style={{ color: "red" }}>*</span> */}
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    autoComplete="off"
                    // value={datas.project_number}
                    // onChange={(e) => {
                    //   HandleChanges(e);
                    //   setProjectER("");
                    // }}
                    // value={
                    //   datas.project_number != "" &&
                    //   datas.project_number != undefined &&
                    //   datas.project_number != null
                    //     ? datas.project_number.slice(0, 20)
                    //     : datas.project_number
                    // }


                    value={
                      datas.project_number != "" &&
                      datas.project_number != undefined &&
                      datas.project_number != null
                        ? datas.project_number
                            .replace(/[^\w\s]/gi, "")
                            .slice(0, 20) // Remove special characters
                        : datas.project_number
                    }
                    // onChange={(e) => {
                    //   HandleChanges(e);
                    //   if (e.target.value.length > 20) {
                    //     setProjectER(
                    //       "*Project Number should not exit 20 characters"
                    //     );
                    //   } else {
                    //     setProjectER("");
                    //   }
                    // }}

                    onChange={(e) => {
                      const value = e.target.value
                        .replace(/[^\w\s]/gi, "")
                        .slice(0, 20);
                      HandleChanges(e);

                      if (value.length > 20) {
                        setErrInde(1);

                        setProjectER(
                          "*Project Number should not exceed 20 characters"
                        );
                      } else if (!/\d/.test(value)) {
                        setErrInde(1);
                        setProjectER(
                          "*Project Number must include at least one digit"
                        );
                      } else {
                        setErrInde(0);

                        setProjectER("");
                      }
                    }}
                    name="project_number"
                    required
                    style={{
                      padding: "10px",
                    }}
                  ></input>
                  <p style={{ color: "red", marginTop: "5px" }}>{projectErr}</p>
                </div>

                <div class="col-6 field-div" style={{ marginBottom: "20px" }}>
                  <label
                    for="validationCustom02"
                    class="form-label"
                    style={{ fontSize: "15px" }}
                  >
                    Descriptions
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    type="text"
                    class="form-control"
                    autoComplete="off"
                    value={datas.description}
                    onChange={(e) => {
                      HandleChanges(e);
                      setDescriptionError("");
                    }}
                    name="description"
                    required
                    style={{
                      padding: "10px",
                    }}
                  ></textarea>
                  <p style={{ color: "red", marginTop: "5px" }}>
                    {DescriptionError}
                  </p>
                </div>
              </form>

              <div
                className="RoleButton"
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "flex-end",
                  padding: "0px 15px",
                  marginBottom: "20px",

                  alignItems: "center",
                }}
              >
                <button
                  class="btn  CancelBtn"
                  type="submit"
                  onClick={(e) => {
                    HandleSubmit(e);

                    HandleEdits(e);
                  }}
                  style={{ padding: "0px 12px" }}
                >
                  {EditId != undefined &&
                  EditId != "" &&
                  State.ClientRetrieves.ClientRetrieve.id
                    ? "Update"
                    : "Submit"}
                </button>

                {/* <button
                  class="btn CancelBtn"
                  style={{
                    color: "#ffff",
                    background: "#F26239",
                    padding: "0px 12px",
                  }}
                  onClick={handleClose}
                >
                  Cancel */}
                {/* </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClientCreate;
